import SmartLink from "../common/smart-link";
import styles from './hero-cta-section-2.module.css';
import NewsletterHeroForm from "../newsletter/newsletter-hero-form";

const buyButton = {
  href: '#order-header',
  label: 'Get the Book',
};

const guideButton = {
  href: '#subscribe',
  label: 'Download Free Guides',
}

const HeroCtaSection2 = () => {
  const handleBuyClick = () => {
    try {
      window.analytics?.trackEvent('cta_buy_book', {
        destination: 'order_header',
        cta_location: 'hero',
        link_text: buyButton.label,
      });
    } catch { }
  };

  const handleGuideClick = () => {
    try {
      window.analytics?.trackEvent('cta_download_guide', {
        destination: 'subscribe',
        cta_location: 'hero',
        link_text: guideButton.label,
      });
    } catch { }
  };

  return (
    <div className={styles.ctaContainer}>
      <div className={styles.ctaGrid}>

        <SmartLink
          href={buyButton.href}
          className={`${styles.ctaButton}`}
          onLinkClick={handleBuyClick}
        >
          {buyButton.label}
        </SmartLink>

        <SmartLink
          href={guideButton.href}
          className={`${styles.guideButton}`}
          onLinkClick={handleGuideClick}
        >
          {guideButton.label}
        </SmartLink>

        {/* <SmartLink href={guideButton.href} className={styles.ctaButton}>
          <span className={styles.guideBadge}>MHT</span>
          <span>{guideButton.label}</span>
        </SmartLink> */}
      </div>

      {/* <NewsletterHeroForm /> */}
    </div>
  );

};

export default HeroCtaSection2;